/**
 * Incentive Badge Modal Handler
 * Handles opening and closing of the Ride Rewards FAQ modal when badge is clicked
 */

(function() {
  'use strict';

  const MODAL_ID = 'js-incentive-badge-modal';
  const BADGE_SELECTOR = '.js-incentive-badge-modal';
  const CLOSE_SELECTOR = '.js-incentive-modal-close';
  const OVERLAY_SELECTOR = '.incentive-badge-modal__overlay';

  function initIncentiveBadgeModal() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) {
      console.warn('Incentive badge modal not found');
      return;
    }

    const badges = document.querySelectorAll(BADGE_SELECTOR);
    const closeBtn = modal.querySelector(CLOSE_SELECTOR);
    const overlay = modal.querySelector(OVERLAY_SELECTOR);

    // Open modal when badge is clicked
    badges.forEach(badge => {
      badge.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
    });

    // Close modal when close button is clicked
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    // Close modal when overlay is clicked
    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }

    // Prevent closing when clicking inside the modal content
    const modalContent = modal.querySelector('.incentive-badge-modal__content');
    if (modalContent) {
      modalContent.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }

    // Close modal on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.style.display !== 'none') {
        closeModal();
      }
    });
  }

  function openModal() {
    const modal = document.getElementById(MODAL_ID);
    if (modal) {
      modal.style.display = 'flex';
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    }
  }

  function closeModal() {
    const modal = document.getElementById(MODAL_ID);
    if (modal) {
      modal.style.display = 'none';
      // Restore body scroll
      document.body.style.overflow = 'auto';
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIncentiveBadgeModal);
  } else {
    initIncentiveBadgeModal();
  }

  // Export for testing or external use
  window.IncentiveBadgeModal = {
    open: openModal,
    close: closeModal,
    init: initIncentiveBadgeModal
  };
})();
